import { dataImageUpload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageUpload = /*#__PURE__*/createIcon(dataImageUpload)
export default IconImageUpload
